import type { FunctionComponent } from 'react'
import React from 'react'
import { SignupButton, TypographyV2 as Typography } from '@which/seatbelt'

import { modalImageProps } from '../../../shared/data'
import styles from '../Filters/Filters.module.scss'

export const FilterSignupCTA: FunctionComponent = () => (
  <>
    <p className={styles.filterCTATextWrapper} data-testid="filters-signup-cta-text-copy">
      <Typography tag="span" textStyle="sb-text-body-small-regular" className={styles.bold}>
        Why join Which?&nbsp;
      </Typography>

      <Typography tag="span" textStyle="sb-text-interface-body-small-regular">
        Our members get the full picture, with all the Best Buy and Don't Buy products.
      </Typography>
    </p>
    <SignupButton
      withModal={true}
      modalImageProps={modalImageProps}
      button={{ text: 'Unlock filters' }}
      data-testid="filters-signup-cta"
      buttonDatalayerTrackingId="filters-signup-cta"
      captionDatalayerTrackingId="signup-cta-compliance-text"
    />
  </>
)
